export default __webpack_public_path__ + "2fd11ec1ad3f8eff5c1c1edd46a6bb21.svg";